import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Blogorola's \"Hot'a'lot\"",
  "description": "",
  "published": "2008-03-18T00:00:00.000Z",
  "redirect_from": ["/blog/blogorolas-hotalot/swizec/121"],
  "categories": "review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Blogorola.com is an awesome thing and a great idea. It's probably the first time I've seen a proper web RSS aggregator in Slovenia. There's been others, but they failed to impress, this one however tickles a certain fancy. it's well designed and looks stunning ... but for the love of all that is blogging, what the hell is going on with that Hot'a'lot thing?`}</p>
    <p>{`Far as I understand it it's supposed to showcase the best of the best. The most current, the most well written, the most interesting and the most loved of blogs. Why is it then that it only ever seems to show blogs from a few different people, most of which are blogorola employees anyway. But ok, I can understand that, the editors feel like their blogs are the most interesting and relevant so those get showcased. Nothing wrong with a bit of self promotion.`}</p>
    <p>{`But I cannot get over the fact that currently it's showing blogs from a `}<strong parentName="p">{`MONTH`}</strong>{` ago! A fucking `}<em parentName="p">{`month`}</em>{` people! What's the use of showcasing a month old blog post? Furthermore, why the fuck do they showcase a newish blog (it's never newer than at least a week old) and then in a few days going `}<strong parentName="p">{`back`}</strong>{` to the one that's from a month ago?`}</p>
    <p>{`Seriously people, that's messed up.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      